<div
  class="w-100 h-100 d-flex align-items-center justify-content-start l-root flex-column">
  <div class="logo-cont">
    <a routerLink="/" class="lo-logo">
      <img
        class="logo"
        [ngSrc]="'assets/logos/logo-full.svg'"
        alt="LSH"
        priority="true"
        width="300"
        height="130" />
    </a>
  </div>
  <router-outlet></router-outlet>
</div>
